// @flow
import { useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';

import type { Node } from 'react';

type TLandingPadProps = {
  htmlId: string
};

type TPortalProps = {
  children: Node,
  htmlId: string
};

export function LandingPad({ htmlId }: TLandingPadProps) {
  return <div id={htmlId} />;
}

export function Portal({ children, htmlId }: TPortalProps) {
  const elRef = useRef(document.createElement('div'));
  const rootRef = useRef();

  useEffect(() => {
    rootRef.current = document && document.getElementById(htmlId);
    rootRef.current && rootRef.current.appendChild(elRef.current);

    return () => {
      rootRef.current && rootRef.current.removeChild(elRef.current);
    };
  }, []);

  return ReactDOM.createPortal(children, elRef.current);
}

LandingPad.defaultProps = {
  htmlId: 'portal-root'
};

Portal.defaultProps = {
  htmlId: 'portal-root'
};
